import * as _ from 'lodash';

import * as events from '../common/events';
import { IWidget } from '../widgets';
import { GridsterOptions } from './gridsterOptions';
import { IGridsterOptions } from '../models';

export interface IWidgetsContainer {
    widgetList: IWidget[];
    gridsterOptions: IGridsterOptions;
    isLoading: boolean;
}

export interface IEditableWidgetsContainer extends IWidgetsContainer {
    selectedItem: IWidget;

    selectItem(item): void;
    isSelected(guid: string): boolean;
    deleteItem(guid: string): void;
    duplicateItem(guid: string): void;
}

export interface IWidgetContainerBase extends IWidgetsContainer {
}

export class WidgetContainerBase implements IWidgetContainerBase {
    static controllerId = 'WidgetContainerBase';

    isEditMode: boolean;
    isLoading: boolean;
    widgetList: IWidget[];
    selectedItem: IWidget;
    gridsterOptions: IGridsterOptions;
    isSuperAdmin: boolean;

    constructor(private _rootScope?: angular.IRootScopeService) {
        this.isLoading = false;
        this.widgetList = [];
        this.gridsterOptions = new GridsterOptions().options();
    }

    isSelected(item: IWidget): boolean {
        return this.isEditMode && this.selectedItem && item === this.selectedItem;
    }

    selectItem(item, $event): void {
        //TODO check if selection can be changed
        if (this.isEditMode) {
            this.setSelectedItem(item);
            $event.preventDefault();
        }
    }

    setSelectedItem(item) {
        this.selectedItem = item;
        //this.$rootScope.$broadcast(events.itemSelected, item);
    }

    togglePropertiesMode(): void {
        if (this._rootScope) {
            this._rootScope.$broadcast(events.togglePropertiesMode);
        } // TODO: should return a error message wheather _rootScope is undefined?
    }

    toggleEditMode() {
        if (this._rootScope) {
            this._rootScope.$broadcast(events.toggleEditMode);
        } // TODO: should return a error message wheather _rootScope is undefined?
    }

    unselect($event) {
        if (!$event.isDefaultPrevented()) {
            this.setSelectedItem(null);
        }
    }

    onIsEditMode(draggable: boolean = true, resizable: boolean = true) {
        const self = this;
        return (event, argument) => {
            if (argument === true) {
                self.gridsterOptions.draggable.enabled = draggable;
                self.gridsterOptions.resizable.enabled = resizable;
            } else {
                self.selectedItem = null;
                self.gridsterOptions.draggable.enabled = false;
                self.gridsterOptions.resizable.enabled = false;
            }
            self.isEditMode = argument;
        };
    }

    onItemSelectionAllowed() {
        const self = this;
        return (event, item) => {
            self.selectedItem = item;
        };
    }

    getItem(guid: string): IWidget {
        const result = _.find(this.widgetList, item => item.guid === guid);
        return result;
    }
}